import { API } from "@/lib/api";

const KEY = "brewer-chat-session";
const makeId = () => `web-${crypto.randomUUID?.() ?? Date.now().toString(36) + Math.random().toString(36).slice(2)}`;

export const getSession = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = makeId();
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const newSession = () => {
  const id = makeId();
  localStorage.setItem(KEY, id);
  return id;
};

export const fetchHistory = (session) => fetch(`${API}/chat/${session}`).then((r) => r.json());

export const submitChatLead = (payload) =>
  fetch(`${API}/chat/lead`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }).then((r) => {
    if (!r.ok) throw new Error("failed");
    return r.json();
  });

export async function streamReply(body, onDelta) {
  const res = await fetch(`${API}/chat/stream`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  if (!res.ok || !res.body) throw new Error("failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      if (!ev.startsWith("data: ")) continue;
      const d = JSON.parse(ev.slice(6));
      if (d.delta) onDelta(d.delta);
      if (d.error) onDelta(d.error);
    }
  }
}

export const parseReply = (text = "") => {
  const i = text.indexOf("[[");
  const body = (i === -1 ? text : text.slice(0, i)).replace(/\[$/, "").trimEnd();
  const actions = (text.match(/\[\[actions:\s*([^\]]*)\]\]/i)?.[1] || "").split(",").map((s) => s.trim().toLowerCase()).filter(Boolean);
  const suggest = (text.match(/\[\[suggest:\s*([^\]]*)\]\]/i)?.[1] || "").split("|").map((s) => s.trim()).filter(Boolean);
  return { body, actions, suggest };
};
